export default "__VITE_ASSET__pZibV10k__"